import { Button, Group, Modal, TextInput } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { useEffect, useState } from "react";

export interface FilterModalProps {
  opened: boolean;
  onClose: () => void;
  dateFrom: string | null;
  dateTo: string | null;
  productFrom: string;
  productTo: string;
  onApply: (filters: {
    dateFrom: string | null;
    dateTo: string | null;
    productFrom: string;
    productTo: string;
  }) => void;
}

const OrderHistoryFilter: React.FunctionComponent<FilterModalProps> = ({
  opened,
  onClose,
  onApply,
  dateFrom: initialDateFrom,
  dateTo: initialDateTo,
  productFrom: initialProductFrom,
  productTo: initialProductTo,
}) => {
  const [dateFrom, setDateFrom] = useState<string | null>(initialDateFrom);
  const [dateTo, setDateTo] = useState<string | null>(initialDateTo);
  const [productFrom, setProductFrom] = useState(initialProductFrom);
  const [productTo, setProductTo] = useState(initialProductTo);

  // Sync props → state when modal opens
  useEffect(() => {
    if (opened) {
      setDateFrom(initialDateFrom);
      setDateTo(initialDateTo);
      setProductFrom(initialProductFrom);
      setProductTo(initialProductTo);
    }
  }, [
    opened,
    initialDateFrom,
    initialDateTo,
    initialProductFrom,
    initialProductTo,
  ]);

  return (
    <Modal opened={opened} onClose={onClose} title="Filters" size="sm" centered>
      <Group grow mb="sm">
        <DateInput
          label="Date From"
          value={dateFrom}
          onChange={setDateFrom}
          valueFormat="YYYY-MM-DD"
          popoverProps={{
            withinPortal: true,
            portalProps: { target: document.body },
            zIndex: 9999,
            width: 300,
          }}
        />

        <DateInput
          label="Date To"
          value={dateTo}
          onChange={setDateTo}
          valueFormat="YYYY-MM-DD"
          popoverProps={{
            withinPortal: true,
            portalProps: { target: document.body },
            zIndex: 9999,
            width: 300,
          }}
        />
      </Group>

      <Group grow mb="md">
        <TextInput
          type="text"
          inputMode="numeric"
          maxLength={6}
          label="Product From"
          value={productFrom}
          onChange={(e) => {
            const v = e.target.value;

            // Allow only digits
            if (!/^\d*$/.test(v)) return;

            setProductFrom(v);
          }}
        />

        <TextInput
          type="text"
          inputMode="numeric"
          maxLength={6}
          label="Product To"
          value={productTo}
          onChange={(e) => {
            const v = e.target.value;

            // Allow only digits
            if (!/^\d*$/.test(v)) return;

            setProductTo(v);
          }}
        />
      </Group>

      <Group justify="flex-end">
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>

        <Button
          onClick={() => {
            onApply({
              dateFrom,
              dateTo,
              productFrom,
              productTo,
            });
            onClose();
          }}
        >
          Apply
        </Button>
      </Group>
    </Modal>
  );
};

export default OrderHistoryFilter;
